



















import {
  Modal, ModalMixin, AsyncBtn,
} from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { setup } from '.';

interface Data {
  task: Promise<void>|null,
  apiKey: string
}

export default ModalMixin.extend({
  props: {
    agencyId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Campaign Monitor API Key',
    },
  },
  data(): Data {
    return {
      task: null,
      apiKey: '',
    };
  },
  computed: {
    canSave(): boolean {
      return (this.apiKey !== '');
    },
  },
  methods: {
    setup(): void {
      if (!this.canSave) return;
      this.task = setup(this.agencyId, this.apiKey);
      this.task.then(() => {
        this.$emit('ok');
        this.hide();
      });
    },
    isGranted,
  },
  components: {
    modal: Modal,
    'async-btn': AsyncBtn,
  },
});
